import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from '@mui/material';
import { camelCaseToWords } from '../../../Utils/Services/ValidationRunService/validationRunService';
import { FormattedMessage } from 'react-intl';

const ValidationSummaryCard = ({ eventType, summary, results = [] }) => {
  const renderStatistics = () => {
    if (!summary?.statistics) {
      return (
        <Typography color="textSecondary">
          <FormattedMessage id="validationRuns.noSummaryData" />
        </Typography>
      );
    }

    return (
      <Box sx={{ mb: 2 }}>
        {Object.entries(summary.statistics).map(([key, value]) => (
          <Typography key={key} variant="body2">
            <strong>
              {camelCaseToWords(key)}
              {':'}
            </strong>{' '}
            {value}
          </Typography>
        ))}
      </Box>
    );
  };

  const renderResultsTable = () => {
    if (results.length === 0) {
      return (
        <Typography color="textSecondary" variant="body2">
          <FormattedMessage id="validationRuns.noResultsData" />
        </Typography>
      );
    }

    return (
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                <FormattedMessage id="validationRuns.table.errorCode" />
              </TableCell>
              <TableCell>
                <FormattedMessage id="validationRuns.table.bsn" />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {results.map((result, index) => (
              <TableRow key={index}>
                <TableCell>{result.errorCode}</TableCell>
                <TableCell>{result.bsn}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <Card sx={{ height: '100%' }}>
      <CardHeader title={<Typography variant="h4">{camelCaseToWords(eventType)}</Typography>} sx={{ pb: 1 }} />
      <CardContent>
        <Typography variant="subtitle2" gutterBottom>
          <FormattedMessage id="validationRuns.summary" />
        </Typography>

        {renderStatistics()}

        {renderResultsTable()}
      </CardContent>
    </Card>
  );
};

export default ValidationSummaryCard;
